import { Text } from "atoms/typography";
import { colors } from "lib/theme";
import styled from "styled-components";
import { space } from "styled-system";

export const LegacyFieldError = styled.p`
  ${space};

  font-size: 14px;
  line-height: 20px;
  color: ${colors.red[500]};
`;

const FieldError = (props) => (
  <Text
    mt="2px"
    display="inline-block"
    fontSize="xs"
    color={colors.pink[500]}
    fontWeight="medium"
    lineHeight={16 / 12}
    transition="0.15s ease-in-out opacity"
    {...props}
  />
);

export default FieldError;
